/* eslint-disable react/no-array-index-key */
import React, { FC } from 'react';

import { Box, useTheme } from '@mui/material';
import Image from 'src/components/atoms/image';

import BundleHeaderBannerHighlightCoverSkeleton from './skeleton';
import { BundleHeaderBannerHighlightCoverStyle, BundleHeaderBannerMultipleCoverStyle } from './style';

import { getAssetUrl } from '@helpers/utils';
import useBundleCourseItem from '@hooks/bundle/useBundleCourseItem';
import useBundleDetail from '@hooks/bundle/useBundleDetail';
import { BundleEntity } from '@redux/bundle/type/BundleDetailType';

const MAX_COVER_IMAGES = 4;

type BundleHeaderBannerHighlightCoverProps = {
  bundleDetailSeo: BundleEntity;
};

const BundleHeaderBannerHighlightCover: FC<BundleHeaderBannerHighlightCoverProps> = ({ bundleDetailSeo }) => {
  const { idName } = bundleDetailSeo;
  const { courseCardImageUrl, isBundleDetailLoading } = useBundleDetail();
  const { bundleCourses, isBundleCoursesLoading } = useBundleCourseItem();
  const theme = useTheme();

  const DEFAULT_BANNER_HIGHLIGHT_COVER = getAssetUrl('thumbnail-course-card.jpg');

  if (isBundleDetailLoading || isBundleCoursesLoading) {
    return <BundleHeaderBannerHighlightCoverSkeleton />;
  }

  if (!courseCardImageUrl && bundleCourses.length > 0) {
    return (
      <BundleHeaderBannerMultipleCoverStyle>
        {Array.from({ length: MAX_COVER_IMAGES }).map((_, index) => {
          const bundleCourse = !!bundleCourses?.[index];
          return bundleCourse ? (
            <Image
              key={index}
              src={bundleCourses[index]?.highlightImage1xUrl || DEFAULT_BANNER_HIGHLIGHT_COVER}
              alt={idName}
              errorImage={DEFAULT_BANNER_HIGHLIGHT_COVER}
            />
          ) : (
            <Box key={index} bgcolor={theme.palette.grey[200]} />
          );
        })}
      </BundleHeaderBannerMultipleCoverStyle>
    );
  }

  return (
    <BundleHeaderBannerHighlightCoverStyle>
      <Image
        src={courseCardImageUrl || DEFAULT_BANNER_HIGHLIGHT_COVER}
        alt={idName}
        errorImage={DEFAULT_BANNER_HIGHLIGHT_COVER}
      />
    </BundleHeaderBannerHighlightCoverStyle>
  );
};

export default BundleHeaderBannerHighlightCover;
